<div class="row mb-2">
  <div class="col-10">
    
    <it-chip
      [label]="'Periodo: ' + formatDateIT(selectedStartDate) + ' → ' + formatDateIT(selectedEndDate)"
      color="primary"
      class="me-2"
    ></it-chip>
    <it-chip [label]="'Pratiche: ' + (form.controls['state'].value=='OPEN' ? 'aperte' : (form.controls['state'].value=='CLOSED' ? 'chiuse' : (form.controls['state'].value=='ANNULLED' ? 'annullate' : 'tutte')))" 
      color="primary"
      class="me-2"
    ></it-chip>
    <it-chip
      [label]="'ASL: ' + ((form.controls['aslCode'].value != 'null' && form.controls['aslCode'].value) ? form.controls['aslCode'].value : 'tutte')"
      color="primary"
      class="me-2"
    ></it-chip>

  </div>
  <div class="col-2 text-end">
    <button
      itButton="outline-warning"
      [size]="'xs'"
      data-bs-toggle="modal"
      data-bs-target="#filterStatsModal"
    >
      <it-icon name="search"></it-icon> Filtra dati
    </button>
  </div>
</div>
<div class="table-container">
<it-table striped="true" bordered="true" class="text-center align-middle" >
  <ng-container thead>
    <tr>
      <th rowspan="2" scope="col" class="top-left colored">Entità {{((form.controls['aslCode'].value != 'null' && form.controls['aslCode'].value)
        ? form.controls['aslCode'].value : '')}}</th>
      <th colspan="1" class="top-left colored fixed">Tutti i setting</th>
      <th colspan="1" class="top-left colored fixed">ADI + Domicilio</th>
      <th colspan="1" class="top-left colored fixed">Hospice e Cure Palliative</th>
      <th colspan="1" class="top-left colored fixed">Ospedale di comunità</th>
      <th colspan="1" class="top-left colored fixed">RP</th>
      <th colspan="1" class="top-left colored fixed">RSA</th>
      <th colspan="1" class="top-left colored fixed">ex art. 26</th>
      <th colspan="1" class="top-left colored fixed">cod.28</th>
      <th colspan="1" class="top-left colored fixed">cod.56</th>
      <th colspan="1" class="top-left colored fixed">cod.60</th>
      <th colspan="1" class="top-left colored fixed">cod.75</th>
      <th colspan="1" class="top-left colored fixed">Altro</th>
    </tr>
    <tr>
      <th scope="col">Pratiche</th>
      <!-- <th scope="col">Pazienti</th> -->
      <th scope="col">Pratiche</th>
      <!-- <th scope="col">Pazienti</th> -->
      <th scope="col">Pratiche</th>
      <!-- <th scope="col">Pazienti</th> -->
      <th scope="col">Pratiche</th>
      <!-- <th scope="col">Pazienti</th> -->
      <th scope="col">Pratiche</th>
      <!-- <th scope="col">Pazienti</th> -->
      <th scope="col">Pratiche</th>
      <!-- <th scope="col">Pazienti</th> -->
      <th scope="col">Pratiche</th>
      <!-- <th scope="col">Pazienti</th> -->
      <th scope="col">Pratiche</th>
      <!-- <th scope="col">Pazienti</th> -->
      <th scope="col">Pratiche</th>
      <!-- <th scope="col">Pazienti</th> -->
      <th scope="col">Pratiche</th>
      <!-- <th scope="col">Pazienti</th> -->
      <th scope="col">Pratiche</th>
      <!-- <th scope="col">Pazienti</th> -->
      <th scope="col">Pratiche</th>
      <!-- <th scope="col">Pazienti</th> -->
    </tr>
  </ng-container>

  <ng-container tbody>
    <tr *ngFor="let row of data.values">
      <td class="top-left">{{ row.entity }}</td>
      <td>{{ row.asl_pra }}</td>
      <!-- <td>{{ row.asl_paz }}</td> -->
      <td>{{ row['adi + domicilio_pra'] || '0' }}</td>
      <!-- <td>{{ row['adi + domicilio_paz'] || '0' }}</td> -->
      <td>{{ row['hospice e cure palliative_pra'] || '0' }}</td>
      <!-- <td>{{ row['hospice e cure palliative_paz'] || '0' }}</td> -->
      <td>{{ row['ospedale di comunità_pra'] || '0' }}</td>
      <!-- <td>{{ row['ospedale di comunità_paz'] || '0' }}</td> -->
      <td>{{ row['residenza protetta (rp)_pra'] || '0' }}</td>
      <!-- <td>{{ row['residenza protetta (rp)_paz'] || '0' }}</td> -->
      <td>{{ row['residenza sanitaria assistenziale (rsa)_pra'] || '0' }}</td>
      <!-- <td>{{ row['residenza sanitaria assistenziale (rsa)_paz'] || '0' }}</td> -->
      <td>{{ row['riabilitazione (ex art. 26)_pra'] || '0' }}</td>
      <!-- <td>{{ row['riabilitazione (ex art. 26)_paz'] || '0' }}</td> -->
      <td>{{ row['post acuzie cod.28_pra'] || '0' }}</td>
      <!-- <td>{{ row['post acuzie cod.28_paz'] || '0' }}</td> -->
      <td>{{ row['post acuzie cod.56_pra'] || '0' }}</td>
      <!-- <td>{{ row['post acuzie cod.56_paz'] || '0' }}</td> -->
      <td>{{ row['post acuzie cod.60_pra'] || '0' }}</td>
      <!-- <td>{{ row['post acuzie cod.60_paz'] || '0' }}</td> -->
      <td>{{ row['post acuzie cod.75_pra'] || '0' }}</td>
      <!-- <td>{{ row['post acuzie cod.75_paz'] || '0' }}</td> -->
      <td>{{ row['altro_pra'] || '0' }}</td>
      <!-- <td>{{ row['altro_paz'] || '0' }}</td> -->
    </tr>
  </ng-container>

  <!-- <ng-container tfoot>
    <tr class="fw-semibold">
      <td class="top-left">Totale</td>
      <td>{{ totals.total_pra}}</td>
      <td>{{ totals.total_pat}}</td>
      <td>{{ totals['adi + domicilio_total_pra']}}</td>
      <td>{{ totals['adi + domicilio_total_pat']}}</td>
      <td>{{ totals['hospice e cure palliative_total_pra']}}</td>
      <td>{{ totals['hospice e cure palliative_total_pat']}}</td>
      <td>{{ totals['ospedale di comunità_total_pra']}}</td>
      <td>{{ totals['ospedale di comunità_total_pat']}}</td>
      <td>{{ totals['residenza protetta (rp)_total_pra']}}</td>
      <td>{{ totals['residenza protetta (rp)_total_pat']}}</td>
      <td>{{ totals['residenza sanitaria assistenziale (rsa)_total_pra']}}</td>
      <td>{{ totals['residenza sanitaria assistenziale (rsa)_total_pat']}}</td>
      <td>{{ totals['riabilitazione (ex art. 26)_total_pra']}}</td>
      <td>{{ totals['riabilitazione (ex art. 26)_total_pat']}}</td>
      <td>{{ totals['post acuzie cod.28_total_pra']}}</td>
      <td>{{ totals['post acuzie cod.28_total_pat']}}</td>
      <td>{{ totals['post acuzie cod.56_total_pra']}}</td>
      <td>{{ totals['post acuzie cod.56_total_pat']}}</td>
      <td>{{ totals['post acuzie cod.60_total_pra']}}</td>
      <td>{{ totals['post acuzie cod.60_total_pat']}}</td>
      <td>{{ totals['post acuzie cod.75_total_pra']}}</td>
      <td>{{ totals['post acuzie cod.75_total_pat']}}</td>
      <td>{{ totals['altro_total_pra']}}</td>
      <td>{{ totals['altro_total_pat']}}</td>
    </tr>
  </ng-container> -->
</it-table>
</div>


<it-modal
  size="xl"
  #rightModal="itModal"
  alignment="right"
  scrollable="true"
  id="filterStatsModal"
>
  <ng-container modalTitle>Filtri ricerca</ng-container>

  <div class="mb-2">
    <it-card teaser="true" shadow="true">
      <h3 class="card-title h5">Periodo estrazione</h3>
      <form [formGroup]="form">
        <div class="row">
          <div class="col-12">
            <it-input
              label="Data inizio"
              [type]="'date'"
              formControlName="dataInizio"
            ></it-input>
          </div>
          <div class="col-12">
            <it-input
              label="Data fine"
              [type]="'date'"
              formControlName="dataFine"
            ></it-input>
          </div>
          <it-select
                  id="default-select"
                  label="Pratiche"
                  formControlName="state"
                >
                  <option [value]="'ALL'">Tutte</option>
                  <option [value]="'OPEN'"> Aperte</option>
                  <option [value]="'CLOSED'"> Chiuse</option>
                  <option [value]="'ANNULLED'"> Annullate</option>
                </it-select>
          <it-select
                  id="default-select"
                  label="ASL"
                  formControlName="aslCode"
                  defaultOption=""
                >
                  <option [value]="null">Seleziona una asl</option>
                  <option [value]="'ASL_1'"> {{ 'ASL 1' }}</option>
                  <option [value]="'ASL_2'"> {{ 'ASL 2' }}</option>
                  <option [value]="'ASL_3'"> {{ 'ASL 3' }}</option>
                  <option [value]="'ASL_4'"> {{ 'ASL 4' }}</option>
                </it-select>
        </div>
        <div class="row">
          <it-select
                  id="default-select"
                  label="Entità"
                  formControlName="entityTypes"
                  defaultOption=""
                >
                  <option [value]="null">Seleziona una entità</option>
                  <option *ngFor ="let actor of entities" [value]="actor.code">{{actor.name}}</option>
                </it-select>
        </div>
        </form>
        <div class="row">
          <div class="col">
            <it-select
                  id="default-select"
                  label="Anno"
                  [(ngModel)]="year"
                  defaultOption=""
                >
                  <option [value]="null">Seleziona un anno</option>
                  <option [value]="2024"> {{ 2024 }}</option>
                  <option [value]="2025"> {{ 2025 }}</option>
                  <option [value]="2026"> {{ 2026 }}</option>
                  <option [value]="2027"> {{ 2027 }}</option>
                  <option [value]="2028"> {{ 2028 }}</option>
                  <option [value]="2029"> {{ 2029 }}</option>
                  <option [value]="2030"> {{ 2030 }}</option>
                  <option [value]="2031"> {{ 2031 }}</option>
                  <option [value]="2032"> {{ 2032 }}</option>
                  <option [value]="2033"> {{ 2033 }}</option>
                  <option [value]="2034"> {{ 2034 }}</option>
                  <option [value]="2035"> {{ 2035 }}</option>
                  <option [value]="2036"> {{ 2036 }}</option>
                </it-select>
            <it-select
                  id="default-select"
                  label="Trimestre"
                  [(ngModel)]="trimestre"
                  defaultOption=""
                  (ngModelChange)="selectedTrimester()"
                  *ngIf="year"
                >
                  <option [value]="null">Seleziona un trimestre</option>
                  <option [value]="'1'"> {{ 'Primo trimestre' }}</option>
                  <option [value]="'2'"> {{ 'Secondo trimestre' }}</option>
                  <option [value]="'3'"> {{ 'Terzo trimestre' }}</option>
                  <option [value]="'4'"> {{ 'Quarto trimestre' }}</option>
                </it-select>
                
          </div>
        </div>
      
    </it-card>
  </div>

  <ng-container footer>
    <button
      itButton="primary"
      size="lg"
      type="button"
      (click)="search()"
      data-bs-dismiss="modal"
      data-bs-dismiss="modal"
    >
      Filtra
    </button>
    <button
      itButton="outline-primary"
      size="lg"
      type="button"
      data-bs-dismiss="modal"
    >
      Chiudi
    </button>
  </ng-container>
</it-modal>